import ApiController from './ApiController';

/**
 * Dados do tipo de patologia
 * @typedef Patologia
 * @property {Number} id Identificador único da patologia
 * @property {String} descricao Descrição da patologia
 */

/**
 * Mensagem de erro retornada pela API ou da validação local
 * @typedef Erro
 * @property {String} codigo Tipo do erro
 * @property {String} campo Campo em que o erro ocorreu
 * @property {String} mensagem Mensagem de erro em português
 */

/**
 * Lista de patologias retornada pela API
 * @typedef Listagem
 * @property {Boolean} sucesso Indica se a requisição foi executada
 * @property {Array<Erro>} erros Listagem dos erros retornados
 * @property {Array<Patologia>} items Em caso de sucesso contém os tipos retornados
 */

/**
 * Controller para listar os tipos de patologias
 */
class PatologiaController {
    constructor() {
        this.apiController = new ApiController();
    }

    /**
     * Lista os tipos de patologias
     * @returns {Promise<Listagem>} Retorna a listagem dos tipos patologia
     */
    async listar() {
        try {
            //Envia requisição para o servidor e captura os dados de resposta
            const { data: items } = await this.apiController.get('/patologia');
            //Marca que houve retorno com sucesso
            const result = {
                sucesso: true,
                items
            };
            return result;
        } catch (error) {
            //Captura o erro e retorna para a aplicação
            return { sucesso: false, erros: error.response.data };
        }

    }
}

export default PatologiaController;